export { default as AboutSectionLayout } from './about-section-layout';
export { default as BusinessPageLayout } from './BusinessPageLayout';
export { default as ProcessSectionLayout } from './process-section-layout';
export { default as SpecialtySectionLayout } from './specialty-section-layout';

export type { AboutSectionLayoutProps } from './about-section-layout';
export type { BusinessPageLayoutProps } from './BusinessPageLayout';
export type { ProcessSectionLayoutProps } from './process-section-layout';
export type { SpecialtySectionLayoutProps } from './specialty-section-layout';
